import dayjs from "dayjs";
import {DatePicker} from "antd";
import {InputField, SelectField} from "~/components/Forms";
import {getGroupSelectOption} from "~/utils";

const typeOptions = [
	{value: '', label: 'Tất cả loại'},
	{value: '3day', label: 'Đánh giá 3 ngày'},
	{value: '7day', label: 'Đánh giá 7 ngày'},
];

const statusOptions = [
	{value: '', label: 'Tất cả kết quả'},
	{value: 'fail', label: 'Chưa đạt'},
	{value: 'pass', label: 'Đạt'},
];

function EvaluationSearchBar({filter, listGroup = [], onSearchChange, onChange}) {

	//Chỉ lấy nhóm thuộc phòng kinh doanh
	const saleGroups   = listGroup.filter((g) => g?.department?.key === 'sales');
	const groupOptions = Object.values(getGroupSelectOption(saleGroups, 'Tất cả phòng kinh doanh'));

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		onSearchChange({...filter, keyword: e.target.value, page: 1});
	};

	const handleTypeChange = (value) => {
		if (!onChange) return;
		onChange({...filter, type: value || undefined, page: 1});
	};

	const handleStatusChange = (value) => {
		if (!onChange) return;
		onChange({...filter, status: value || undefined, page: 1});
	};

	const handleGroupChange = (value) => {
		if (!onChange) return;
		onChange({...filter, groupId: (value && value !== '0') ? value : undefined, page: 1});
	};

	const handleDateChange = (date) => {
		if (!onChange) return;
		onChange({...filter, evaluateDate: date ? date.startOf('day').unix() : undefined, page: 1});
	};

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField name="keyword" placeholder="Tên, tài khoản nhân viên" onChange={handleKeywordChange} />
					<SelectField name="groupId" placeholder="Phòng kinh doanh" options={groupOptions} value={filter?.groupId || undefined} onChange={(value) => handleGroupChange(value)} />
					<DatePicker
						format="DD/MM/YYYY"
						placeholder="Ngày đánh giá"
						value={filter?.evaluateDate ? dayjs.unix(filter.evaluateDate) : undefined}
						onChange={handleDateChange}
						style={{height: 38}}
						allowClear
					/>
					<SelectField name="type" placeholder="Loại đánh giá" options={typeOptions} onChange={(value) => handleTypeChange(value)} />
					<SelectField name="status" placeholder="Kết quả" options={statusOptions} value={filter?.status || undefined} onChange={(value) => handleStatusChange(value)} />
				</form>
			</div>
		</div>
	);
}

export default EvaluationSearchBar;
